<template>
  <component :is="tagName" :href="hrefLink" class="group-card-container" :style="{width}">
    <div :style="cardStyle" :class="className">
      <AspectRatio class="group-card_image" :ratio="ratio">
        <van-image :src="data.image_url" :fit="fit" width="100%" height="100%"/>
        <div class="groupon-member" v-if="config.show_sell_number">已售{{data.sell_count}}</div>
      </AspectRatio>
      <div class="groupon-banner">
        <template v-if="isBig">
          <div class="banner-label">
            <svg-icon name="com_groupon"/>
            <span class="banner-text">拼团</span>
          </div>
          <CountDown v-if="config.show_count_down" show-days :start="data.begin_time" :end="data.end_time"/>
        </template>
        <template v-else>
          <CountDown v-if="config.show_count_down" start-label="距开始" online-label="距结束" dot-gap inline show-days :start="data.begin_time" :end="data.end_time"/>
          <span v-else>拼团</span>
        </template>
      </div>
      <div :class="infoClass" v-if="showInfo">
        <div class="goods_card_name" v-if="config.show_title">
          <p class="name" :style="[400,500][config.text_style_type]"><span class="groupon-num">{{data.complete_groupon_desc
}}</span>{{data.title}}</p>
        </div>
        <div class="goods_card_price" v-if="config.show_price||config.show_origin_price||config.show_buy_btn">
          <div class="price-block" v-if="config.show_price||config.show_origin_price">
            <p class="price" v-if="config.show_price">￥{{data.groupon_price}}</p>
            <p class="origin-price" v-if="config.show_origin_price">￥{{data.origin_price}}</p>
          </div>
          <BuyBtn :config="config"/>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
  import BuyBtn from '../BuyBtn';
  import AspectRatio from "@/components/AspectRatio";
  import CountDown from "@/components/CountDown";
  import GoodsCard from '../mixins/GoodsCard';

  export default {
	name: "GrouponCard",
	props: {
	  config: Object,
	  data: Object,
	  index: Number
	},
	mixins: [GoodsCard],
	components: {AspectRatio, BuyBtn, CountDown},
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../style/groupon-card";

  .goods_card_name {
    .groupon-num {
      line-height: 20px;
      font-size: 12px;
      color: #FF6B0D;
      background-color: #FFE7D6;
      display: inline-block;
      padding: 0 5px;
      border-radius: 8px;
      margin-right: 5px;
    }
  }
</style>
